import { reportError, flushErrorsOnUnload } from './reporter';

/**
 * Instala handlers globales para capturar errores fuera del árbol React:
 * - `window.onerror` — errores síncronos en scripts.
 * - `window.onunhandledrejection` — promise rejections no atrapados.
 * - `beforeunload` — flush del buffer del reporter antes de cerrar tab.
 *
 * Llamar UNA vez al boot (main.tsx). Idempotente — re-llamarlo no duplica listeners.
 */

let installed = false;

export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    reportError(event.error ?? event.message, 'window.onerror');
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportError(event.reason, 'window.unhandledrejection');
  });

  // Flush antes de cerrar tab / navegar fuera.
  window.addEventListener('beforeunload', () => {
    flushErrorsOnUnload();
  });

  // En visibility change a hidden también flusheamos (mobile / tab switch).
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      flushErrorsOnUnload();
    }
  });
}
